import { css } from "@emotion/react"

export const pointer = css`
  cursor: pointer;
`

export const not_allowed = css`
  cursor: not-allowed;
`
